import Modal from "components/Modal/Modal";
import { useSelector } from "react-redux";
import {
  deleteExpense,
  deleteExpenseById,
  selectExpenseForDeletion,
  selectState,
  setDeleteExpenseModalOpen
} from "../main.slice";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";

const DeleteExpenseModal = () => {
  const { deleteExpenseModalOpen } = useSelector(selectState);
  const expense = useSelector(selectExpenseForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteExpenseModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      await dispatch(deleteExpense(expense.expenseId));
      dispatch(deleteExpenseById(expense.expenseId));
      toast.success("Uspešno obrisan.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteExpenseModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje troška">
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći trošak?
        <br />
        <br />
        <b>{expense?.title}</b>
      </p>
    </Modal>
  )
};

export default DeleteExpenseModal;
